import React from 'react';
import { Box, Typography } from '@mui/material';
import { getTextColor } from '../../../../utils/colorUtils';

/**
 * Month legend item component that shows a single item in the month legend
 * 
 * @param {Object} props
 * @param {Object} props.item - Item to display
 * @param {Date} props.date - Date for the item
 * @param {Object} props.contentTypeColors - Map of content types to colors
 * @returns {JSX.Element}
 */
const MonthLegendItem = ({ item, date, contentTypeColors }) => {
    // Get the background color - treat RandomSimulation as Simulation
    const getBackgroundColor = (contentType) => {
        if (contentType === 'RandomSimulation') {
            return contentTypeColors['Simulation'] || '#999';
        }
        return contentTypeColors[contentType] || '#999';
    };

    const backgroundColor = getBackgroundColor(item.contentType);

    // Determine text color based on background color
    const textColor = getTextColor(backgroundColor);

    // Helper function to get the appropriate display name with prefix for special types
    const getDisplayName = (item) => {
        const baseName = item.contentName || item.contentId;

        // Add "Random - " prefix for RandomSimulation items
        if (item.contentType === 'RandomSimulation') {
            return `Random - ${baseName}`;
        }

        // Add "Pack - " prefix for ContentPack items
        if (item.contentType === 'ContentPack') {
            return `Pack - ${baseName}`;
        }

        // For regular Simulation and Course, use the base name
        return baseName;
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{
                width: '20px',
                height: '20px',
                borderRadius: '4px',
                backgroundColor: backgroundColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Typography variant="caption" color={textColor} fontWeight="bold">
                    {date.getDate()}
                </Typography>
            </Box>
            <Typography variant="body2" noWrap sx={{ maxWidth: '250px' }}>
                {getDisplayName(item)}
            </Typography>
        </Box>
    );
};

export default React.memo(MonthLegendItem);